export default {
  en: {
    department: 'segment | segments',
    segment: 'segment | segments',
    agent: 'agent | agents',
    admin: 'admin | admins',
    subscription: 'subscription | subscriptions',
    business: 'business | businesses',
    integration: 'integration | integrations',
    developer: 'developer | webhooks',
    channel: 'channel | channels',
    user: 'user | users',
    metric: 'metric | metrics',
    privilege: 'privileges | privileges',
    call: 'call | calls',
    web: 'web',
    kiosk: 'kiosk | kiosks',
    form: 'form | forms',
    survey: 'survey | surveys',
    ip: 'IP address | IP addresses',
    webhook: 'webhook | webhooks',
    secret: 'secret | availabilities',
    tag: 'tag | tags',
    availability: 'availability | availabilities',
    service: 'calendar | calendars',
    'recordings-settings': 'recording setting | recordings settings',
    abandonReason: 'abandon reason | abandon reasons',
    'custom-email': 'custom email | custom emails',
    notification: 'notification | notifications',
    comment: 'comment | comments',
    customerForm: 'customer form | customer forms',
    agentForm: 'agent form | agent forms',
    recording: 'recording | recordings',
    exportation: 'exportation | exportations',
    branch: 'branch | branches',
    poc: 'poc | pocs',
    referrer: 'link | links',
    aiTopic: 'topic | topics',
    customer: 'customer | customers',
    'working-hours': 'working hour | working hours',
    contacts: 'contact | contacts',
    restriction: 'restriction | restrictions',
    extension: 'extension | extensions',
    'content-block': 'content block | content blocks',
  },
  es: {
    department: 'segmento | segmentos',
    segment: 'segmento | segmentos',
    agent: 'agente | agentes',
    admin: 'administrador | administradores',
    subscription: 'suscripción | suscripciones',
    business: 'empresa | empresas',
    integration: 'integración | integraciones',
    developer: 'desarrollador | desarrolladores',
    channel: 'canal | canales',
    user: 'usuario | usuarios',
    metric: 'métrica | métricas',
    privilege: 'privilegio | privilegios',
    call: 'llamada | llamadas',
    web: 'web',
    kiosk: 'quiosco | quioscos',
    form: 'formulario | formularios',
    survey: 'encuesta | encuestas',
    ip: 'dirección IP | direcciones IP',
    webhook: 'webhook | webhooks',
    secret: 'secreto | secretos',
    tag: 'etiqueta | etiquetas',
    availability: 'disponibilidad | disponibilidades',
    service: 'calendario | calendarios',
    'recordings-settings': 'ajuste de grabación | ajustes de grabación',
    abandonReason: 'razón de abandono | razones de abandono',
    'custom-email': 'email personalizado | email personalizados',
    notification: 'notificación | notificaciones',
    comment: 'comentario | comentarios',
    customerForm: 'formulario cliente | formularios cliente',
    agentForm: 'formulario agente | formularios agente',
    recording: 'grabación | grabaciones',
    exportation: 'exportación | exportaciones',
    branch: 'sucursal | sucursales',
    poc: 'poc | pocs',
    referrer: 'enlace | enlaces',
    aiTopic: 'tópico | tópicos',
    customer: 'cliente | clientes',
    'working-hours': 'hora laboral | horas laborales',
    contacts: 'contacto | contactos',
    restriction: 'restricción | restricciones',
    extension: 'extensión | extensiones',
    'content-block': 'bloque de contenido | bloques de contenido',
  },
  fr: {
    department: 'segment | segments',
    segment: 'segment | segments',
    agent: 'agent | agents',
    admin: 'admin | admins',
    subscription: 'abonnement | abonnements',
    business: 'entreprise | entreprises',
    integration: 'intégration | intégrations',
    developer: 'développeur | développeurs',
    channel: 'canal | canaux',
    user: 'utilisateur | utilisateurs',
    metric: 'métrique | métriques',
    privilege: 'privilège | privilèges',
    call: 'appel | appels',
    web: 'web',
    kiosk: 'kiosque | kiosques',
    form: 'formulaire | formulaires',
    survey: 'enquête | enquêtes',
    ip: 'adresse IP | adresses IP',
    webhook: 'webhook | webhooks',
    secret: 'secret | secrets',
    tag: 'étiquette | étiquettes',
    availability: 'disponibilité | disponibilités',
    service: 'calendrier | calendriers',
    'recordings-settings': 'paramètre d\'enregistrement | paramètres d\'enregistrement',
    abandonReason: 'raison d\'abandon | raisons d\'abandon',
    'custom-email': 'email personnalisé | emails personnalisés',
    notification: 'notification | notifications',
    comment: 'commentaire | commentaires',
    customerForm: 'formulaire client | formulaires clients',
    agentForm: 'formulaire agent | formulaires agents',
    recording: 'enregistrement | enregistrements',
    exportation: 'exportation | exportations',
    branch: 'branche | branches',
    poc: 'poc | pocs',
    referrer: 'lien | liens',
    aiTopic: 'sujet | sujets',
    customer: 'client | clients',
    'working-hours': 'heures de travail | heures les travaux',
    contacts: 'contact | contacts',
    restriction: 'restriction | restrictions',
    extension: 'extension | extensions',
    'content-block': 'bloc de contenu | blocs de contenu',
}

};
